<template>
  <div>
    <MdSwitch
      :value="!status"
      :class="[disabled ? '' : 'md-primary']"
      :disabled="disabled"
      @change="onToggle"
    />
  </div>
</template>

<script>
import { actions } from '@/vuex/modules/advertiser/insertionOrders/constants'
import {
  actions as snackbarActions,
  snackbarType,
} from '@/vuex/modules/ui/snackbar/constants'

export default {
  name: 'StatusSwitch',
  props: { status: Boolean, insertionOrder: Object, disabled: Boolean },
  methods: {
    async onToggle() {
      const insertionOrder = this.insertionOrder
      const toActive = !insertionOrder.isActive
      const status = toActive ? 'active' : 'inactive'
      const statusText = toActive ? '有効' : '無効'
      const result = await this.$confirm(
        `${insertionOrder.name}を${statusText}にしますがよろしいですか？`,
      )
      if (result) {
        try {
          await this.$store.dispatch(actions.SET_IO_STATUS, {
            insertionOrder,
            status,
          })
          this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
            type: snackbarType.SUCCESS,
            message: `ステータスを${statusText}にしました。`,
          })
        } catch (e) {
          const message = 'ステータスの変更に失敗しました'
          this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
            type: snackbarType.ERROR,
            message,
          })
        }
      }
    },
  },
}
</script>
